import script from "./CommonElButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonElButton.vue?vue&type=script&setup=true&lang=js"

import "./CommonElButton.vue?vue&type=style&index=0&id=ba660656&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba660656"]])

export default __exports__